import baseFetch, { createParamString } from '../baseFetch';

export const fetchRegionalOverview = (subregionId, cookies) =>
  baseFetch(`/kbyg/regions/overview?subregionId=${subregionId}`, { cookies });

export const fetchNearbySubregions = (subregionId, cookies) =>
  baseFetch(`/kbyg/regions/nearby?subregionId=${subregionId}`, { cookies });

export const fetchRegionalArticles = async (subregionId, cookies) =>
  baseFetch(`/feed/regional?${createParamString({ subregionId })}`, { cookies });
